export default "__VITE_ASSET__DSH6XQzP__"